import React, {useContext} from "react";
import {TimelineFrameCareUnitContext} from "./TimelineFrameContentCareUnitWrapper";
import {OTLink} from "../../../../../../components/tag/OTLink";
import {FormattedMessage} from "react-intl";
import OTIcon from "../../../../../../components/tag/OTIcon";
import {TimelineFrameDataContext} from "../../../../TimelineFramePage";
import {TYPE_GTI} from "../../../../../../definitions/TimelineItems";
import Span from "../../../../../../components/tag/Span";
import Row from "../../../../../../components/tag/Row";
import {COXA_GENERIC_CAREUNIT_SEGMENT_PHRASE_KEYWORD, COXA_GENERIC_PHRASE_TYPE} from "../../../../TimelineFrameUtils";

let { id: module_id } = module;
export const TimelineFrameContentCareUnit = () => {
    const { data, genericPhrases } = useContext(TimelineFrameDataContext);
    const careUnit = useContext(TimelineFrameCareUnitContext);

    const getMessageForLink = () => {
        if (careUnit.coxa) {
            const coxaGenericPhrases = genericPhrases.find(e => e.type === COXA_GENERIC_PHRASE_TYPE);

            if (coxaGenericPhrases) {
                const coxaAppointmentSegmentGenericPhrase =
                    coxaGenericPhrases.phrases.find(p => p.key.includes(COXA_GENERIC_CAREUNIT_SEGMENT_PHRASE_KEYWORD));

                if (coxaAppointmentSegmentGenericPhrase) {
                    return (
                        <Row>
                            <Span>
                                <p>{coxaAppointmentSegmentGenericPhrase.value}</p>
                            </Span>
                        </Row>
                    );
                }
            }
        } else {
            return (
                <FormattedMessage
                    id={`${module_id}.MUNP.careUnitDetails`}
                    values={{
                        a: (chunks) =>  <OTLink
                            target="_blank"
                            onClick={(e) => e.stopPropagation()}
                            link={careUnit.linkValue}
                            isExternal
                            className="card-link"
                        >{chunks}</OTLink>
                    }}
                />
            );
        }
    }

    return (
        <>
            <div className="span12">
                {/* <i className="card-icon icon-info" />{' '} */}
                {getMessageForLink()}
                {/* data.type !== TYPE_GTI && !careUnit.coxa &&
                    <OTIcon
                        style={{ padding: '2px' }}
                        config={{
                            type: 'fa',
                            name: 'icon-external-link',
                            color: 'blue',
                        }}
                    />
                */}
            </div>
        </>
    );
}